import axios from "axios";
import Vue from "vue";

export default {
  state: () => ({
    selectedBookingClass: { cabinClass: {}, fareFamily: {} },
    bookingClasses: [],
  }),

  mutations: {
    setSelectedBookingClass(state, bookingClass) {
      Vue.set(state, "selectedBookingClass", bookingClass);
    },
    setBookingClasses(state, bookingClasses) {
      Vue.set(state, "bookingClasses", bookingClasses);
    },
    setBookingClassModule(state, bookingClasses) {
      Vue.set(state, "selectedBookingClass", { cabinClass: {}, fareFamily: {} });
      Vue.set(state, "bookingClasses", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createBookingClass: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/booking-classes/entity", request, {}).then((response) => {
        // console.log(response.data)
        return response;
      });
    },
    loadBookingClasses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/booking-classes/entity").then((response) => {
        // context.commit("setBookingClasses",response.data)
        return response.data;
      });
    },
    loadPublishedBookingClasses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/booking-classes/entity/published").then((response) => {
        return response.data;
      });
    },
    loadPublishedBookingClassesFromTmsCdn: (context) => {
      return axios.get(context.getters.getTmsCdnServiceUrl + "/booking-classes.json").then((response) => {
        return response.data;
      });
    },
    loadBookingClass: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/booking-classes/entity/" + request.id).then((response) => {
        context.commit("setSelectedBookingClass", response.data);
        return response;
      });
    },
    deleteBookingClass: (context, bookingClass) => {
      return axios.delete(context.getters.getMcServiceUrl + "/booking-classes/entity/" + bookingClass.id).then((response) => {
        return response.data;
      });
    },

    deleteDraftBookingClass: (context, bookingClass) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/booking-classes/draft/" + bookingClass.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    sendToApprovalBookingClasses: (context, bookingClass) => {
      return axios.get(context.getters.getMcServiceUrl + "/booking-classes/sendToApproval/" + bookingClass.intentId).then((response) => {
        return response.data;
      });
    },
    publishBookingClasses: (context, bookingClass) => {
      return axios.get(context.getters.getMcServiceUrl + "/booking-classes/publish/" + bookingClass.intentId).then((response) => {
        if (bookingClass.intents[0].type === "DELETE_BOOKING_CLASS") {
          let bookingClasses = context.getters.getBookingClasses;
          bookingClasses.splice(bookingClasses.indexOf(bookingClass), 1);
          context.commit("setBookingClasses", bookingClasses);
        }
        return response.data;
      });
    },
    rejectBookingClasses: (context, bookingClass) => {
      return axios.get(context.getters.getMcServiceUrl + "/booking-classes/reject/" + bookingClass.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedBookingClass: (state) => {
      return state.selectedBookingClass;
    },
    getBookingClasses: (state) => {
      return state.bookingClasses;
    },
  },
};
